/**
 * Guardar una corrección sin notificar al cliente.
 *
 * Varias ediciones del panel disparan avisos automáticos en la base (pago aplicado, efectivo
 * 75/85/100 %, acuerdo liquidado, documento validado o rechazado, forma de pago, contrato firmado).
 * Cuando es una corrección, el panel pregunta "¿Notificar al cliente?" (`ui/pregunta-notificar`) y,
 * con "No", manda el header `x-sozu-silenciar-avisos: on` en la MISMA petición del guardado: la base
 * lo acepta solo de personal interno (`sozu_avisos_silenciados()`, migración 20261105120000) y se
 * apaga al terminar esa petición. Queda registro de quién hizo el cambio.
 *
 * Sin la migración en el ambiente, el header se ignora y se guarda como antes (con avisos).
 */

export const HEADER_SILENCIAR_AVISOS = 'x-sozu-silenciar-avisos';

/** Agrega el header de silencio a una consulta de PostgREST (update, insert o rpc) si no se notifica. */
export function conAvisos<Q extends { setHeader(nombre: string, valor: string): Q }>(consulta: Q, notificar: boolean): Q {
  return notificar ? consulta : consulta.setHeader(HEADER_SILENCIAR_AVISOS, 'on');
}

/** Estatus de documento: 1 Pendiente, 2 Validado, 3 Rechazado, 4 Expirado. */
const ESTATUS_REVISADO = new Set([2, 3]);

/**
 * Cambiar el estatus de un documento pregunta solo si es una corrección: el documento ya estaba
 * validado o rechazado y cambia. Validar o rechazar por primera vez avisa directo, porque ese aviso
 * es el que el cliente espera (decisión de Eduardo 2026-10-31).
 */
export function estatusDocumentoPreguntaAviso(anterior: number | null | undefined, nuevo: number | null | undefined): boolean {
  return anterior != null && ESTATUS_REVISADO.has(anterior) && nuevo !== anterior;
}
